import { Map } from 'immutable';
import moment from 'moment';

export function timeDifference(givenTime) {
  givenTime = new Date(givenTime);
  const milliseconds = new Date().getTime() - givenTime.getTime();
  const numberEnding = number => {
    return number > 1 ? 's' : '';
  };
  const number = num => num > 9 ? '' + num : '0' + num;
  const getTime = () => {
    let temp = Math.floor(milliseconds / 1000);
    const years = Math.floor(temp / 31536000);
    if (years) {
      const month = number(givenTime.getUTCMonth() + 1);
      const day = number(givenTime.getUTCDate());
      const year = givenTime.getUTCFullYear() % 100;
      return `${day}-${month}-${year}`;
    }
    const days = Math.floor((temp %= 31536000) / 86400);
    if (days) {
      if (days < 28) {
        return days + ' day' + numberEnding(days);
      } else {
        const months = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];
        const month = months[givenTime.getUTCMonth()];
        const day = number(givenTime.getUTCDate());
        return `${day} ${month}`;
      }
    }
    const hours = Math.floor((temp %= 86400) / 3600);
    if (hours) {
      return `${hours} hour${numberEnding(hours)} ago`;
    }
    const minutes = Math.floor((temp %= 3600) / 60);
    if (minutes) {
      return `${minutes} minute${numberEnding(minutes)} ago`;
    }
    return 'a few seconds ago';
  };
  return getTime();
}

export const renewPolicyRange = expirationDay => {
  let today = new Date();
  let todayMoment = moment(today);
  let expirationDate = moment(expirationDay);
  let expirationMoment = moment(expirationDate);
  let daysLeft = expirationMoment.diff(todayMoment, "days");
  let isInexpirationRange = daysLeft <= 45 && daysLeft > 0 ? true : false;
  let isExpired = daysLeft < 0 ? true : false;
  return { daysLeft, isInexpirationRange, isExpired };
};

export const setTimeToTimer = (eprezto_vehiculos_dt) => {
  let vigencia = eprezto_vehiculos_dt && eprezto_vehiculos_dt.Vigf;
  let vigfYear = vigencia && vigencia.split("-")[0];
  let vigfMonth = vigencia && vigencia.split("-")[1];
  let vigfDate = vigencia && vigencia.split("-")[2];
  let vigfToCounter = new Date(vigfYear, vigfMonth-1, vigfDate, 0, 0, 0, 0);

  return vigfToCounter;
}

export const renewPolicyRangeWithDate = (expirationDay) => {
  let vigencia = expirationDay;
  let vigfYear = vigencia && vigencia.split("-")[0];
  let vigfMonth = vigencia && vigencia.split("-")[1];
  let vigfDate = vigencia && vigencia.split("-")[2];
  let vigfFinalValue = new Date(vigfYear, vigfMonth - 1, vigfDate, 0, 0, 0, 0);

  /* Date today */
  let today = new Date();
  let expirationDate = vigfFinalValue;
  let dataExpiredPolicy = {};

  if (today > expirationDate) {
    
    let diffTime = Math.abs(today - expirationDate);
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    dataExpiredPolicy.isExpired = true;
    dataExpiredPolicy.daysLeft = diffDays;
    dataExpiredPolicy.vigStart = setFormatDateToString(new Date());

  } else {
    dataExpiredPolicy.isExpired = false;
    dataExpiredPolicy.vigStart = setFormatDateToString(new Date(expirationDate));
  }
  return dataExpiredPolicy;
};

export const setFormatDateToString = (dateToFormat) => {
  let date = dateToFormat.getDate();
  let year = dateToFormat.getFullYear();
  let month = dateToFormat.getMonth() + 1;

  month = month < 10 ? `0${month}` : month;
  date = date < 10 ? `0${date}` : date;

  return `${date}/${month}/${year}`;
};

export const setInsuranceNameToFetch = (insurance) => {
  let insuranceName = '';

  switch(insurance){
    case "sura": 
      insuranceName = "SURA"; break;
    case "internacional": 
      insuranceName = "Internacional"; break;
    case "regional":
      insuranceName = "Regional"; break;
    case "fedpa":
      insuranceName = "FEDPA"; break;
  }

  return insuranceName;
}

/* REGEX */
export const yellowRegex = /[a-z0-9]?[aA](maril|MARIL)[a-z0-9]*/;
export const visaLogo = 'https://d29fo3cabnm3fy.cloudfront.net/visa.png';
export const mastercardLogo = 'https://d29fo3cabnm3fy.cloudfront.net/masterCard.png';
export const yappyLogo = 'https://d29fo3cabnm3fy.cloudfront.net/yappy-ico.svg';
export const ACHLogo = 'https://d29fo3cabnm3fy.cloudfront.net/ACH3x.png';
export const payCashLogo = 'https://d29fo3cabnm3fy.cloudfront.net/PayCash.png';
export const AMOUNT_REFERRED_DISCOUNT_RENEW = 8;

export const getSubscriptionStartDate = (currentDate) => {
  console.log("Geeting date subscription");
  let subscriptionDay = currentDate.getDate();
  let subscriptionFinalDay =
    subscriptionDay < 10
      ? "0" + subscriptionDay.toString()
      : subscriptionDay.toString();
  let subscriptionMonth = currentDate.getMonth() + 1;
  let subscriptionYear = currentDate.getFullYear();

  if (subscriptionMonth === 12) {
    subscriptionMonth = 1;
    subscriptionYear++;
  } else {
    subscriptionMonth++;
  }
  if (subscriptionMonth < 10) {
    subscriptionMonth = "0" + subscriptionMonth.toString();
  }

  if (
    (subscriptionMonth.toString() === "04" ||
      subscriptionMonth.toString() === "06" ||
      subscriptionMonth.toString() === "09" ||
      subscriptionMonth.toString() === "11") &&
    subscriptionFinalDay === "31"
  ) {
    const date = new Date(currentDate);
    let miFecha = new Date(date.getFullYear(), date.getMonth() + 2, 0);
    subscriptionFinalDay = miFecha.getDate();
  }
  if (
    subscriptionMonth.toString() === "02" &&
    (subscriptionFinalDay === "29" ||
      subscriptionFinalDay === "30" ||
      subscriptionFinalDay === "31")
  ) {
    const date = new Date(currentDate);
    let miFecha = new Date(date.getFullYear(), date.getMonth() + 2, 0);
    subscriptionFinalDay = miFecha.getDate();
  }
  return `${subscriptionYear}${subscriptionMonth}${subscriptionFinalDay}`;
}

export const getBeneficioGrua = (insurance) => {
  let gruaBenefits = insurance?.policy_benefits?.one;
  let splittedText = gruaBenefits?.split(' (');
  let gruaText = splittedText?.length > 0 ? splittedText[0] : "";
  return gruaText;
}

export const setFullNameSplitted = (pay_card_name) => {
  let fullname_array = pay_card_name.split(/\s/).filter(item => item !== '');
  let fullname_array_length = fullname_array.length;
  let driver_names = null;
  let driver_surnames = null;

  switch (fullname_array_length) {
    case 2:
      driver_names = fullname_array[0];
      driver_surnames = fullname_array[1];
      break;
    case 3:
      driver_names = `${fullname_array[0]} ${fullname_array[1]}`;
      driver_surnames = fullname_array[2];
      break;
    case 4:
      driver_names = `${fullname_array[0]} ${fullname_array[1]}`;
      driver_surnames = `${fullname_array[2]} ${fullname_array[3]}`;
      break;
    case 5:
      driver_names = `${fullname_array[0]} ${fullname_array[1]}`;
      driver_surnames = `${fullname_array[2]} ${fullname_array[3]} ${fullname_array[4]}`;
      break;
    case 6:
      driver_names = `${fullname_array[0]} ${fullname_array[1]}`;
      driver_surnames = `${fullname_array[2]} ${fullname_array[3]} ${fullname_array[4]} ${fullname_array[5]}`;
      break;
    case 7:
      driver_names = `${fullname_array[0]} ${fullname_array[1]}`;
      driver_surnames = `${fullname_array[2]} ${fullname_array[3]} ${fullname_array[4]} ${fullname_array[5]} ${fullname_array[6]}`;
      break;

    default:
      break;
  }

  return {
    driver_names,
    driver_surnames
  }
}

export const isValidDate = (day, month, year) => {

  console.log("My month ", month);
  day = parseInt(day, 10);
  month = parseInt(month, 10);
  year = parseInt(year, 10);

  // Check if the year is valid
  if (year < 1) return false;

  // Check if the month is valid
  if (month < 1 || month > 12) return false;

  // Check if the day is valid
  if (day < 1 || day > 31) return false;

  // Check for months with 30 days
  if (month === 4 || month === 6 || month === 9 || month === 11) {
    if (day > 30) return false;
  }

  // Check for February
  if (month === 2) {
    // Check for leap year
    const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    if (isLeapYear) {
      if (day > 29) return false;
    } else {
      if (day > 28) return false;
    }
  }

  return true;
}

export const ciaSegConv = {
  6: "SURA",
  51: "OPTIMA",
  58: "REGIONAL",
  15: "INTERNACIONAL",
  0: "INTERNACIONAL",
  2: "ASSA",
  10: "MAPFRE",
  7: "ANCON",
  17: "FEDPA"
};

export const imagenesAseguradorasCiaSeg = {    
  15: "https://d29fo3cabnm3fy.cloudfront.net/is-logo@3x.png",
  0: "https://d29fo3cabnm3fy.cloudfront.net/is-logo@3x.png",
  7: "https://d29fo3cabnm3fy.cloudfront.net/ancon-logo@3x.png",
  2: "https://d29fo3cabnm3fy.cloudfront.net/assa-logo@3x.png",
  58: "https://d29fo3cabnm3fy.cloudfront.net/regional-logo-mobile@3x.png",
  6: "https://d29fo3cabnm3fy.cloudfront.net/sura-logo@3x.png",
  51: "https://d29fo3cabnm3fy.cloudfront.net/optima_logo_clipped.png",
  10: "https://d29fo3cabnm3fy.cloudfront.net/mapfre@3x.png",
  17: "https://epreztoimagebucket.s3.us-east-2.amazonaws.com/fedpa.jpeg",      
}

export const dataDTCompletedValidator = (obj) => {
  
  const requiredFields = [
      "marca",
      "modelo",
      "ano",
      "customer_email",
      "customer_fullname",
      "borndate_day",
      "borndate_month",
      "borndate_year",
      "placa"
  ];

  let validatorResult = objectValidator(requiredFields, obj);

  console.log("Validate map ---> ", validatorResult);
  let isCompleted = validatorResult.filter(item => !item)
  console.log("Completed  ---> ", isCompleted);
  return isCompleted?.length > 0 ? false: true;

}

// Generic function to validate an object with specifics fields
export const objectValidator = (requiredFields, obj) => {
  return requiredFields.map(field => {
    const value = obj[field];
    return (
      obj.hasOwnProperty(field) &&
      value !== null &&
      value !== undefined &&
      value !== "" &&
      !(typeof value === "object" && Object.keys(value).length === 0) // Check for empty object
    );
  });
};

